import MembersListPage from './MembersListPage';
import _MemberPage from './MemberPage';

export const MemberPage = _MemberPage;
export default MembersListPage;
